document.addEventListener('DOMContentLoaded', function () {
  function initializeCardSwiper(cardElement) {
    const sliderEl = cardElement.querySelector('[data-product-card-slider]');
    if (!sliderEl) return;
    if (window.productCardSwipers) {
      const existingIndex = window.productCardSwipers.findIndex(obj => obj.el === sliderEl);
      if (existingIndex > -1) {
        if (window.productCardSwipers[existingIndex].swiper) {
          window.productCardSwipers[existingIndex].swiper.destroy(true, true);
        }
        window.productCardSwipers.splice(existingIndex, 1);
      }
    }

    const swiperInstance = new Swiper(sliderEl, {
      loop: false,
      pagination: {
        nested: true,
        touchStartPreventDefault: false,
        allowTouchMove: true,
        el: sliderEl.querySelector('[data-swiper-progress-bar]'),
        type: 'progressbar',
      },
    });

    if (!window.productCardSwipers) {
      window.productCardSwipers = [];
    }

    window.productCardSwipers.push({
      id: sliderEl.getAttribute('data-product-id'),
      swiper: swiperInstance,
      el: sliderEl
    });
  }

  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('[data-related-product-swatch]');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();

      const handle = swatch.getAttribute('data-related-product-handle');
      const productCard = swatch.closest('[data-product-card]');

      if (!handle || !productCard) return;

      const figure = productCard.querySelector('[data-product-card-figure]');
      if (!figure) return;

      figure.style.opacity = '0.5';

      const currentActive = productCard.querySelector('[data-color-swatch-active]');
      if (currentActive) {
        currentActive.classList.remove('color-swatch__active');
        currentActive.removeAttribute('data-color-swatch-active');
      }
      swatch.classList.add('color-swatch__active');
      swatch.setAttribute('data-color-swatch-active', true);

      fetch(`/products/${handle}?section_id=ajax-product-card`)
        .then(response => response.text())
        .then(responseText => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(responseText, 'text/html');
          const newProductCard = doc.querySelector('[data-product-card]');

          if (newProductCard) {
            const newFigure = newProductCard.querySelector('[data-product-card-figure]');
            if (newFigure) {
              figure.replaceWith(newFigure);
              initializeCardSwiper(productCard);
            }
          }
        })
        .catch(err => {
          console.error('Failed to fetch related product card:', err);
          figure.style.opacity = '1';
        });
    }
  });
});
